<template>
    <div class="container page-termos">

        <h2>TERMOS DE UTILIZAÇÃO.</h2>

        <h3>VISÃO GERAL</h3>
        <p>Esse site é operado pelo URLinks. Em todo o site, os termos “nós”, “nos” e “nosso” se referem ao URLinks. O URLinks proporciona esse site, incluindo todas as informações, ferramentas e Utilizaçãos disponíveis deste site para você, o usuário, com a condição da sua aceitação de todos os termos, condições, políticas e avisos declarados aqui.</p>
        <p>Ao visitar nosso site, utilizar as ferramentas nele apresentadas, acessar outros sites a partir do URLinks e/ou comprar alguma coisa no nosso site, você está utilizando nossos “Utilizaçãos”. Consequentemente, você concorda com os seguintes termos e condições (“Termos de Utilização”, “Termos”), incluindo os termos e condições e políticas adicionais mencionados neste documento e/ou disponíveis por hyperlink. Esses Termos de Utilização se aplicam a todos os usuários do site, incluindo, sem limitação, os usuários que são navegadores, fornecedores, anunciantes, clientes, lojistas e/ou contribuidores de conteúdo, pessoas físicas e ou jurídicas.</p>
        <p>Por favor, leia esses Termos de Utilização cuidadosamente antes de acessar ou utilizar o nosso site. Ao acessar ou usar qualquer parte do site, você concorda com os Termos de Utilização. Se você não concorda com todos os termos e condições desse acordo, então você não pode acessar o site ou usar quaisquer Utilizaçãos. Se esses Termos de Utilização são considerados uma oferta, a aceitação é expressamente limitada a esses Termos de Utilização.</p>
        <p>Quaisquer novos recursos ou ferramentas que forem adicionados ao site e/ou sua plataforma também devem estar sujeitos aos Termos de Utilização. Você pode revisar a versão mais atual dos Termos de Utilização quando quiser nesta página. Reservamos o direito de atualizar, alterar ou trocar qualquer parte desses Termos de Utilização ao publicar atualizações e/ou alterações no nosso site. É sua responsabilidade verificar as alterações feitas nesta página periodicamente. Seu uso contínuo ou acesso ao site após a publicação de quaisquer alterações constitui aceitação de tais alterações.</p>
        <h3>SEÇÃO 1 - TERMOS DA PLATAFORMA</h3>
        <p>Ao concordar com os Termos de Utilização, você confirma que você é maior de idade em seu estado ou província de residência e que você nos deu seu consentimento para permitir que qualquer um dos seus dependentes menores de idade usem esse site.</p>


        <button class="button" @click="goBack">Voltar</button>

    </div>

</template>
<style>

 .page-termos{ padding:40px 0;}
 body.is-mobile .page-termos{ padding:40px 20px;}

 .page-termos h3 { font-weight:bold; margin:20px 0 10px; font-size: 1.2em; }
    .page-termos h2 {
        color: #00b3bc;
        font-size: 30px;
        font-weight: bold;
        margin-bottom:20px;
    }
    .page-termos p {
        color:#333;
        text-align: justify;
        line-height: 1.4;
        margin-bottom:15px;
    }

</style>



<script>
    export default {
        methods: {
            goBack(){
                this.$router.back();
            },
        },
    }
</script>
